import type { FC, PropsWithChildren } from 'react';

type GlobalLayoutProps = PropsWithChildren;

export const GlobalLayout: FC<GlobalLayoutProps> = ({ children }) => {
  return (
    <div className="bg-neutral-2 flex h-screen w-screen flex-col overflow-hidden">
      {children}
    </div>
  );
};
